import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import projectQueryParameters, {
	type ProactiveSupportSettingsProjectQuery,
} from '@jira/servicedesk__proactive-support-settings/src/__generated__/ProactiveSupportSettingsProjectQuery.graphql.ts';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { ProjectSettingsServicedeskProactiveSupportAppExtraProps } from './projectSettingsServicedeskProactiveSupport.entrypoint.types.tsx';

type ProjectSettingsServicedeskProactiveSupportAppEntryPointProps = EntryPointComponent<
	{
		projectQuery: ProactiveSupportSettingsProjectQuery;
	},
	Record<string, never>,
	{},
	ProjectSettingsServicedeskProactiveSupportAppExtraProps
>;

export const projectSettingsServicedeskProactiveSupportAppEntryPoint: EntryPoint<
	ProjectSettingsServicedeskProactiveSupportAppEntryPointProps,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<ProjectSettingsServicedeskProactiveSupportAppEntryPointProps>(
		/* webpackChunkName: "async-project-settings-proactive-support", jiraSpaEntry: "async-project-settings-proactive-support" */
		'./ProjectSettingsServicedeskProactiveSupportApp.tsx',
	),
	getPreloadProps: ({ context: { match }, tenantContext }: EntryPointRouteParams) => {
		const projectKey = String(match.params.projectKey ?? '');

		return {
			extraProps: {
				projectKey,
				cloudId: tenantContext.cloudId,
			},
			// Preload the project lookup so the numeric projectId (needed to build the JSM space ARI for
			// the onboarding-status query) is resolved during route transition rather than after mount.
			queries: {
				projectQuery: {
					parameters: projectQueryParameters,
					variables: {
						cloudId: tenantContext.cloudId,
						projectKey,
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
